import { render } from "./TheHeader.vue?vue&type=template&id=c7bdaf5a&bindings={\"isAuthenticated\":\"options\",\"activeUser\":\"options\"}"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"
script.render = render

export default script